import { render, staticRenderFns } from "./BillReceivebleCancelForm.vue?vue&type=template&id=5b7cca6b"
import script from "./BillReceivebleCancelForm.vue?vue&type=script&lang=js"
export * from "./BillReceivebleCancelForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports